import React, { useCallback } from 'react';
import { SectionTitle, SliderRow } from './ui-primitives';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Upload, X } from 'lucide-react';
export function LogoPanel({ settings, update }) {
    const handleFileChange = useCallback((e) => {
        const file = e.target.files?.[0];
        if (!file)
            return;
        const reader = new FileReader();
        reader.onload = (ev) => {
            const src = ev.target?.result;
            if (typeof src !== 'string')
                return;
            const img = new Image();
            img.onload = () => {
                update('logoImg', img);
                update('logoEnabled', true);
            };
            img.src = src;
        };
        reader.readAsDataURL(file);
    }, [update]);
    const clearLogo = useCallback(() => {
        update('logoImg', null);
        update('logoEnabled', false);
    }, [update]);
    return (<div className="space-y-4">
            <div className="flex items-center justify-between">
                <SectionTitle>Logo Overlay</SectionTitle>
                <div className="flex items-center gap-2">
                    <Switch id="logo-enabled" checked={settings.logoEnabled} onCheckedChange={(v) => update('logoEnabled', v)} disabled={!settings.logoImg} aria-label="Enable logo"/>
                    <Label htmlFor="logo-enabled" className="text-xs">
                        {settings.logoEnabled ? 'On' : 'Off'}
                    </Label>
                </div>
            </div>

            <p className="text-xs text-muted-foreground">
                Adding a logo reduces scannability. We automatically use high error-correction (H) to compensate.
            </p>

            <div className="space-y-2">
                {settings.logoImg ? (<div className="flex items-center gap-3">
                        <img src={settings.logoImg.src} alt="Logo preview" className="w-14 h-14 rounded-md object-contain border border-border bg-white" loading="lazy"/>
                        <Button variant="outline" size="sm" onClick={clearLogo} className="gap-1.5">
                            <X className="h-3.5 w-3.5"/>
                            Remove
                        </Button>
                    </div>) : (<label className="flex flex-col items-center justify-center gap-2 p-6 border-2 border-dashed border-border rounded-lg cursor-pointer hover:border-violet-400 transition-colors">
                        <Upload className="h-5 w-5 text-muted-foreground"/>
                        <span className="text-xs text-muted-foreground">Click to upload PNG, JPG, SVG</span>
                        <input type="file" accept="image/*" onChange={handleFileChange} className="sr-only" aria-label="Upload logo image"/>
                    </label>)}
            </div>

            {settings.logoImg && (<div className="space-y-3">
                    <SectionTitle>Logo Size</SectionTitle>
                    <SliderRow label="Size" value={settings.logoSize} min={0.1} max={0.35} step={0.01} onChange={(v) => update('logoSize', v)} display={`${Math.round(settings.logoSize * 100)}%`}/>
                </div>)}
        </div>);
}
